// Limites de calendário num só lugar. O mês e o dia do usuário começam à
// meia-noite *dele*, não em UTC (ADR-0003): uma visita às 23h do dia 31
// pertence ao mês que termina. Os limites saem em ISO com `Z` porque é o
// único formato que o app fala por dentro — o fuso entra no cálculo, não
// no valor guardado.
function intervalo(inicio, proximoInicio) {
    return {
        de: inicio.toISOString(),
        ate: new Date(proximoInicio.getTime() - 1).toISOString(),
    };
}
/** Mês de calendário do usuário, com `mes` de 1 a 12. */
export function limitesDoMes(ano, mes) {
    return intervalo(new Date(ano, mes - 1, 1), new Date(ano, mes, 1));
}
/** Dia de calendário do usuário que contém `agora`. */
export function limitesDoDia(agora) {
    const ano = agora.getFullYear();
    const mes = agora.getMonth();
    const dia = agora.getDate();
    return intervalo(new Date(ano, mes, dia), new Date(ano, mes, dia + 1));
}
/**
 * Os mesmos limites em milissegundos, com o fim **exclusivo** — a forma que
 * as comparações de intervalo querem. O `+ 1` mora só aqui.
 */
export function limitesEmMilissegundos(limites) {
    return {
        inicio: new Date(limites.de).getTime(),
        fim: new Date(limites.ate).getTime() + 1,
    };
}
/** Se o instante ISO cai no intervalo. Data inválida nunca cai. */
export function dentroDe(iso, limites) {
    const t = new Date(iso).getTime();
    const { inicio, fim } = limitesEmMilissegundos(limites);
    return t >= inicio && t < fim;
}
//# sourceMappingURL=limitesDoMes.js.map